import { render } from "./WolfVisionView.vue?vue&type=template&id=f829085a"
import script from "./WolfVisionView.vue?vue&type=script&lang=js"
export * from "./WolfVisionView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/builds/JFRxnycJ/0/firma/firmenwebseite/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__